"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getThemeSpace = exports.getModeSpace = void 0;

var _stylesUtils = require("./stylesUtils");

var getModeSpace = function getModeSpace(spacing, mode) {
  return (0, _stylesUtils.px)(spacing / (mode === 'dense' ? 2 : 1));
};

exports.getModeSpace = getModeSpace;

var getThemeSpace = function getThemeSpace(_ref, defaultSpace) {
  var mode = _ref.mode,
      selectors = _ref.selectors;
  var gap = selectors.space(defaultSpace);

  if (!gap) {
    return defaultSpace;
  }

  return getModeSpace(gap, mode);
};

exports.getThemeSpace = getThemeSpace;